<template lang="pug">
.paragraph(v-if="hasText" v-html="paragraph")
</template>
<script>
// Utils
import { get, isObject, isString } from 'lodash';

export default {
    name: 'Paragraph',

    props: {
        eventDetails: {
            type: Object,
            required: true
        },

        text: {
            type: [String, Object],
            default: null
        }
    },

    computed: {
        hasText() {
            return this.paragraph.length > 0;
        },

        paragraph() {
            let text = '';

            if (isString(this.text)) {
                text = this.text;
            } else if (isObject(this.text)) {
                text = this.$utils.locales.getBestTranslation({
                    translations: this.text,
                    preferredLocale: this.$i18n.locale,
                    workspaceLocales: this.eventDetails.languages,
                });
            }

            return text.trim();
        }
    }
}
</script>
